import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SeoService } from './seoService'
import { ServiceProviderAdapterSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderAdapterSymbol).to(SeoService)
}

export const editor = site
